angular.module("app").controller("AddSkinPageController", [
    '$scope',
    'generalService',
    'errorHandler',
    'logger',
    'preloadedLanguages',
    '$timeout',
    'preloadedSkins',
    '$uibModalInstance',
    'preloadedLicense',
    'releaseServers',
    'preloadedProducts',
    function ($scope, generalService, errorHandler, logger, preloadedLanguages, $timeout, preloadedSkins, $modalInstance, preloadedLicense, releaseServers, preloadedProducts) {
        var init;
        $scope.showAuthenticationFieldsRequired = {
            show: false
        };

        $scope.products = preloadedProducts;


        (init = function () {
            $scope.skin = {
                id: "",
                url: "",
                mobile_url: "",
                name: "",
                base_host: "",
                defaultLang: "",
                languages: [],
                ownContentLanguages: [],
                confSkin: [],
                authLogin: "",
                authPass: "",
                license_id: preloadedLicense[0].id,
                server: releaseServers.webDefault,
                mobile_server: releaseServers.mobileDefault,
                new_mobile_url: "",
                new_mobile_server:releaseServers.mobileDefault,
                new_web_url: "",
                new_web_server:releaseServers.webDefault,
                products: []
            };
        })();

        $scope.tooltip = {
            id: ""
        };
        var languageTitleNameMap = {};
        var languageNameTitleMap = {};
        $scope.languageTitles = preloadedLanguages.languages.map(function (item) {
            var title = item.title + " (" + item.name.toUpperCase() +")";
            languageTitleNameMap[title] = item.name;
            languageNameTitleMap[item.name] = title;
            return title;
        });
        $scope.languages = {
            selected: []
        };

        $scope.confSkin = angular.copy(preloadedSkins);

        $scope.ownContentLanguages = {
            selected: []
        };
        $scope.licenses = preloadedLicense;
        $scope.releaseServers = releaseServers.web;
        $scope.mobileReleaseServers = releaseServers.mobile;
        function getSelectedLanguages () {
            var arr = [],
                languages = [],
                i = 0,
                length = preloadedLanguages.languages.length;

            $scope.skin.languages.forEach(function (languageObj) {
                languages.push(languageObj.id)
            });

            for (i, length; i < length; i++) {
                if (languages.indexOf(preloadedLanguages.languages[i]["name"]) != -1) {
                    arr.push(angular.copy(preloadedLanguages.languages[i]))
                }
            }
            return arr
        }

        $scope.filterOptions = {
            skinId:  preloadedSkins[0].id
        };

        $scope.onSkinSelect = function () {
            return function () {
                $timeout(function () {
                    $scope.resetConfigs($scope.filterOptions.skinId.id, true, true)
                })
            }()
        };

        $scope.save = function () {
            if (!$scope.add_skin_form.$valid) {
                $scope.isSavePressed = true;
                $scope.showAuthenticationFieldsRequired.show = !!($scope.skin.authLogin || $scope.skin.authPass);
                return;
            }
            var requestData = {
                skin: angular.copy($scope.skin)
            };

            var languages = $scope.languages.selected,
                ownContentLanguages = $scope.ownContentLanguages.selected;

            requestData.skin.languages = [];
            requestData.skin.ownContentLanguages = [];

            languages.forEach(function (languageObj) {
                requestData.skin.languages.push(languageTitleNameMap[languageObj])
            });

            ownContentLanguages.forEach(function (languageObj) {
                requestData.skin.ownContentLanguages.push(languageTitleNameMap[languageObj])
            });

            requestData.skin.defaultLang && (requestData.skin.defaultLang = languageTitleNameMap[requestData.skin.defaultLang] );

            requestData.skin.confSkin = $scope.filterOptions.skinId;

            generalService.createSkin(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("Skin has been successfully created");
                        init();
                        $scope.add_skin_form && $scope.add_skin_form.$setPristine && $scope.add_skin_form.$setPristine();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
